import { render, staticRenderFns } from "./DocumentsManagerProjects.vue?vue&type=template&id=728cad68"
import script from "./DocumentsManagerProjects.vue?vue&type=script&lang=ts"
export * from "./DocumentsManagerProjects.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('728cad68')) {
      api.createRecord('728cad68', component.options)
    } else {
      api.reload('728cad68', component.options)
    }
    module.hot.accept("./DocumentsManagerProjects.vue?vue&type=template&id=728cad68", function () {
      api.rerender('728cad68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/documents/manager/DocumentsManagerProjects.vue"
export default component.exports